<script>
import SubHeader from "@/components/SubHeader";
export default {
  components: {
    SubHeader,
  },
  data: () => ({
    headerProps: {
      title: "Gerenciar Motoristas",
      btns: [
        {
          text: "Novo",
          color: "primary",
          action: () => {},
          icon: "mdi-plus",
          path: "/cadastros/motoristas/new",
          isRedirector: true,
        },
        {
          text: "Recarregar",
          color: "primary",
          action: () => {},
          icon: "mdi-update",
          path: "",
          isRedirector: false,
        },
      ],
    },
    dialog: false,
    search: "",
    headers: [
      { text: "Nome", value: "nome", sortable: false },
      { text: "CPF", value: "cpf", sortable: false },
      { text: "Telefone", value: "telefone", sortable: false },
      { text: "Ativo", value: "ativo", sortable: false },
      { text: "Ações", value: "action", sortable: false, align: "right" },
    ],
    items: [],
  }),
  created() {
    this.initialize();
    this.headerProps.btns[1].action = () => this.initialize();
  },

  methods: {
    handleSearch: function (value) {
      this.search = value;
    },
    initialize() {
      this.items = [];
      this.$store.dispatch("activeLoader", true);
      this.$http.get("/motoristas").then((r) => {
        this.items = r.data;
        this.$store.dispatch("activeLoader", false);
      });
    },
    editar(id) {
      this.$router.push(`/cadastros/motoristas/editar/${id}`);
    },
    ativarOuDesativarMotorista(id, ativo) {
      let c = confirm(
        `Deseja ${ativo == 1 ? "desativar" : "ativar"} o registro?`
      );
      if (c) {
        this.$store.dispatch("activeLoader", true);
        this.$http
          .post(`/motoristas/ativar/${id}`, { ativo: ativo == 1 ? 0 : 1 })
          .then((r) => {
            this.$store.dispatch("activeLoader", false);
            this.$store.dispatch("showMessage", {
              show: true,
              color: "success darken-1",
              text: r.data.success,
            });
            this.initialize();
          });
      }
    },
  },
};
</script>
